import apiService from '../Api'
import IFilter, { IRefundsAnswer, IRefundStorePayload, IUpdateValuePayload } from './interfaces'

export default class RefundsService {
  async list(filter: IFilter) {
    return apiService.get(`/refunds`, { params: filter })
  }

  async get(id: number) {
    return apiService.get(`/refunds/${id}`)
  }

  async getQuestions() {
    return apiService.get(`/refunds/questions`)
  }

  async getAnswers(id: number) {
    return apiService.get(`/refunds/answers/${id}`)
  }

  async store(payload: IRefundStorePayload) {
    return apiService.post(`/refunds`, payload)
  }

  async storeAnswers(id: number, payload: IRefundsAnswer[]) {
    return apiService.post(`/refunds/${id}`, payload)
  }

  async delete(id: number) {
    return apiService.delete(`/refunds/${id}`)
  }

  async updateValue(id: number, payload: IUpdateValuePayload) {
    return apiService.post(`/refunds/update-value/${id}`, payload)
  }
}
